var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3335 6.5H14.3418L10.6835 1.025C10.3502 0.533333 9.62516 0.533333 9.30016 1.025L5.64183 6.5H1.66683C1.2085 6.5 0.833496 6.875 0.833496 7.33333C0.833496 7.40833 0.841829 7.48333 0.866829 7.55833L2.9835 15.2833C3.17516 15.9833 3.81683 16.5 4.5835 16.5H15.4168C16.1835 16.5 16.8252 15.9833 17.0252 15.2833L19.1418 7.55833L19.1668 7.33333C19.1668 6.875 18.7918 6.5 18.3335 6.5ZM9.99183 2.99167L12.3335 6.5H7.65016L9.99183 2.99167ZM10.0002 13.1667C9.0835 13.1667 8.3335 12.4167 8.3335 11.5C8.3335 10.5833 9.0835 9.83333 10.0002 9.83333C10.9168 9.83333 11.6668 10.5833 11.6668 11.5C11.6668 12.4167 10.9168 13.1667 10.0002 13.1667Z",
    fill: "#054FF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlue);
export default __webpack_public_path__ + "static/media/cart-blue.2b460c60e5225fefab1ababbc2a58dca.svg";
export { ForwardRef as ReactComponent };